<template>
  <footer id="footer" class="container mt-10 mb-2 h-auto pb-4 md:pb-0">
    <div class="flex flex-col justify-center px-8 py-4 md:mx-8">
      <p
        class="m-auto my-2 flex justify-center divide-x divide-purple-500 text-xs *:px-1 first:*:pr-1 last:*:pl-1 max-md:grid max-md:grid-cols-2 max-md:gap-1 max-md:divide-x-0 max-md:text-center md:w-1/2"
      >
        <RouterLink
          :to="{
            name: 'docs-document',
            params: { document: 'company-privacy-policy' },
          }"
          class="inline-link"
        >
          Company Privacy Policy
        </RouterLink>
        <RouterLink
          :to="{
            name: 'docs-document',
            params: { document: 'application-privacy-policy' },
          }"
          class="inline-link"
        >
          App Privacy Policy
        </RouterLink>
        <RouterLink
          :to="{
            name: 'docs-document',
            params: { document: 'disclosures' },
          }"
          class="inline-link"
        >
          Disclosures
        </RouterLink>
        <a
          href="https://community.fyr.ai/hc/en-us"
          target="_blank"
          rel="noopener noreferrer"
          class="inline-link"
          @click="onHelpCenterClick"
        >
          Help Center
        </a>
      </p>
      <div class="m-auto flex justify-center md:w-1/2">
        <span class="text-sm text-gray-500">
          &#169; {{ currentYear }} Fyr. All rights reserved.
        </span>
      </div>
    </div>
  </footer>
</template>

<script setup lang="ts">
import { useTrack } from "@/services/gtm";

const track = useTrack();

const currentYear = new Date().getFullYear();
function onHelpCenterClick(): void {
  track("click_help_center_footer");
}
</script>
